/**
 * Safe localStorage wrapper with fallback to memory
 */
class Storage {
  private memoryStorage: Map<string, string> = new Map()
  private useLocalStorage: boolean = false

  constructor() {
    this.useLocalStorage = this.checkLocalStorageAvailable()
  }

  private checkLocalStorageAvailable(): boolean {
    try {
      const testKey = '__radar_snap_test__'
      localStorage.setItem(testKey, 'test')
      localStorage.removeItem(testKey)
      return true
    } catch {
      return false
    }
  }

  public set(key: string, value: string): void {
    try {
      if (this.useLocalStorage) {
        localStorage.setItem(key, value)
      } else {
        this.memoryStorage.set(key, value)
      }
    } catch (error) {
      console.warn('[RadarSnap] Storage error:', error)
      this.memoryStorage.set(key, value)
    }
  }

  public get(key: string): string | null {
    try {
      if (this.useLocalStorage) {
        return localStorage.getItem(key)
      } else {
        return this.memoryStorage.get(key) || null
      }
    } catch (error) {
      console.warn('[RadarSnap] Storage error:', error)
      return this.memoryStorage.get(key) || null
    }
  }

  public remove(key: string): void {
    try {
      if (this.useLocalStorage) {
        localStorage.removeItem(key)
      } else {
        this.memoryStorage.delete(key)
      }
    } catch (error) {
      console.warn('[RadarSnap] Storage error:', error)
      this.memoryStorage.delete(key)
    }
  }

  public clear(): void {
    try {
      if (this.useLocalStorage) {
        // Only clear RadarSnap keys
        Object.keys(localStorage)
          .filter(key => key.startsWith('_radar_snap_'))
          .forEach(key => localStorage.removeItem(key))
      } else {
        this.memoryStorage.clear()
      }
    } catch (error) {
      console.warn('[RadarSnap] Storage error:', error)
      this.memoryStorage.clear()
    }
  }
}

export default new Storage()